import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "../base-icon";
export const GoIcon = ({ color , size =24 , ...props })=>/*#__PURE__*/ _jsx(BaseIcon, {
        ...props,
        color: color,
        height: size,
        width: size,
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M11.72 22.47a.75.75 0 1 0 1.06 1.06l11-11a.75.75 0 0 0 0-1.06l-11-11a.75.75 0 1 0-1.06 1.06l9.72 9.72H.75a.75.75 0 0 0 0 1.5h20.69l-9.72 9.72Z"
        })
    });
